import { useContext } from 'react';

import { UIContext } from '../contexts';

// ----------------------------------------------------------------------

const useUIContext = () => {
  const context = useContext(UIContext);

  if (!context) throw new Error('UI context must be use inside UIProvider');

  return context;
};

export default useUIContext;
